import { PolygonSymbol as sPolygonSymbol } from "@evergis/sgis/es/symbols/polygon/Simple";
import { isDashedBrush, PolygonSymbol } from "../../interfaces/style";
import { getParameterValue } from "../../evergis/core/classification/getFromClassified";
import { getLineDash } from "./SymbolRenderer/strokeStyle";
import { getHexColor } from "../../utils/color";

export class SGisPolygonSymbol extends sPolygonSymbol {
  constructor(public originalSymbol: PolygonSymbol) {
    super({
      strokeColor: getHexColor(getParameterValue(originalSymbol.stroke?.color)),
      strokeWidth: getParameterValue(originalSymbol.stroke?.width),
      lineDash: getLineDash(originalSymbol.stroke),
      fillColor: getHexColor(getParameterValue(originalSymbol.fill?.color)),
      // TODO?: may be it should be defined by user
      lineCap: isDashedBrush(originalSymbol.stroke) ? "square" : "round",
    });
  }

  clone() {
    return new SGisPolygonSymbol(this.originalSymbol);
  }
}
